import { useTranslation } from 'react-i18next';
import { AlertTriangle, AlertOctagon, Info } from 'lucide-react';

import { cn } from '@/lib/utils';

export type ExceptionSeverity = 'info' | 'warning' | 'error' | 'critical';

interface Props {
  severity: ExceptionSeverity;
  className?: string;
}

const toneClass: Record<ExceptionSeverity, string> = {
  info: 'efs-bg-info',
  warning: 'efs-bg-warning',
  error: 'efs-bg-error',
  critical: 'efs-bg-critical',
};

const Icon: Record<ExceptionSeverity, typeof Info> = {
  info: Info,
  warning: AlertTriangle,
  error: AlertOctagon,
  critical: AlertOctagon,
};

export const ExceptionSeverityBadge = ({ severity, className }: Props) => {
  const { t } = useTranslation();
  const Glyph = Icon[severity];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium uppercase tracking-wide',
        toneClass[severity],
        className,
      )}
    >
      <Glyph className="h-3 w-3" />
      {t(`efs.common.status.${severity}`, { defaultValue: severity })}
    </span>
  );
};
